import type { ReactNode } from "react";

interface ContainerProps {
  children: ReactNode;
  className?: string;
}

export const Container = ({ children, className }: ContainerProps) => {
  return <div className={`flex min-h-[52px] items-center border-b border-[#EEEFF1] px-4 py-2 ${className}`}>{children}</div>;
};
